const TOKEN_VALIDATION_KEY = 'validating-token'

class RefreshTokenSemaphore {
  constructor() {
    this.promissesToResolve = [];
    this.resolveWaitPromise = null;
    this.lockSemaphore = false;
  }

  releaseLock = () => {
    if (this.isLocked() && this.promissesToResolve.length > 0) {
      this.promissesToResolve.forEach(resolvePromisseFunction => {
        resolvePromisseFunction();
      })

      this.promissesToResolve = [];
    }
    this.unlockTokenValidation();
  }

  waitTillUnlockTokenValidation = () => new Promise((resolve, _) => {
    const index = this.promissesToResolve.length > 0 ? this.promissesToResolve.length : 0;

    this.promissesToResolve[index] = () => resolve();
  });

  isLocked = () => !!this.lockSemaphore;

  lockTokenValidation = () => this.lockSemaphore = true;

  unlockTokenValidation = () => this.lockSemaphore = false;
}

const refreshTokenSemaphore = new RefreshTokenSemaphore();

export default refreshTokenSemaphore;